import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { DetailPage } from './DetailPage.jsx';
import { ConsentManager } from './components/ConsentManager.jsx';
import { DriverApplicationPage, DriverApplicationReceivedPage } from './DriverApplicationPage.jsx';
import { FaqPage } from './FaqPage.jsx';
import { HomePage } from './HomePage.jsx';
import { GeneralApplicationPage, GeneralApplicationReceivedPage } from './GeneralApplicationPage.jsx';
import { InfoPage } from './InfoPage.jsx';
import { PaymentSuccessPage } from './PaymentSuccessPage.jsx';
import { LoginPage, PortalDashboardPage } from './PortalAuthPages.jsx';
import { AboutPage, CareersPage, ContactPage, FutureOpportunitiesPage, SignInPage, IndustriesPage, JobsPage, LocationsPage, PartnersPage, RequestDeliveryPage, ServicesPage, TrackingPage } from './PublicPages.jsx';
import { initializeConversionTracking } from './services/analytics.js';
import './styles/global.css';

initializeConversionTracking();

const route = window.location.pathname.split('/').filter(Boolean);
const pageRoutes = {
  services: <ServicesPage />,
  industries: <IndustriesPage />,
  locations: <LocationsPage />,
  'track-delivery': <TrackingPage />,
  'request-delivery': <RequestDeliveryPage />,
  partners: <PartnersPage />,
  'future-opportunities': <FutureOpportunitiesPage />,
  about: <AboutPage />,
  contact: <ContactPage />,
  careers: <CareersPage />,
  jobs: <JobsPage />,
  'sign-in': <SignInPage />,
  login: <LoginPage />,
  portal: <PortalDashboardPage />,
  'employee-access': <SignInPage />,
  faq: <FaqPage />,
  privacy: <InfoPage pageName="privacy" />,
  terms: <InfoPage pageName="terms" />,
};

let content = <HomePage />;
if (route.length === 2 && ['services', 'locations'].includes(route[0])) content = <DetailPage type={route[0]} slug={route[1]} />;
else if (route.join('/') === 'careers/drivers/apply') content = <DriverApplicationPage />;
else if (route.join('/') === 'careers/drivers/application-received') content = <DriverApplicationReceivedPage />;
else if (route.join('/') === 'careers/application-received') content = <GeneralApplicationReceivedPage />;
else if (route.join('/') === 'careers/apply') content = <GeneralApplicationPage />;
else if (route.join('/') === 'careers/drivers') content = <InfoPage pageName="drivers" />;
else if (route.join('/') === 'payment/success') content = <PaymentSuccessPage />;
else if (route.length === 1 && pageRoutes[route[0]]) content = pageRoutes[route[0]];

createRoot(document.getElementById('root')).render(<StrictMode>{content}<ConsentManager/></StrictMode>);
